﻿//////////////////////////////////////////////////////////////////////////////////////////////////////////////
//    IMPORTANT!!!!                                                                                         //
//    This function doesn't catch errors, only throws them.                                                 //
//    When using it you MUST wrap this fetch in a try-catch block!                                          //
//////////////////////////////////////////////////////////////////////////////////////////////////////////////
export default function submitForm(bucket, data) {
    return fetch(bucket, {
        method: 'POST',
        headers: {
            "Content-Type": "application/json",
        },
        body: data
    }).then((response) => {
        if (response.ok) {
            return response.text()
        }
        else {
            throw new Error('Something went wrong!')
        }
    })
}